import {mainQuery} from '@github-ui/react-core/future/main-query'
import {artifactRegistryAppBuilder} from '../config/app-builder'
import type {ArtifactRegistryIndexPayload, ArtifactRegistryShowRoutePayload} from '../types'

export const artifactRegistryIndexRoute = artifactRegistryAppBuilder.createQueryRouteConfig(
  'artifactRegistryIndexRoute',
  {
    path: '/orgs/:org/artifacts',
    queries: [mainQuery<ArtifactRegistryIndexPayload>()],
  },
)

export const artifactRegistryShowRoute = artifactRegistryAppBuilder.createQueryRouteConfig(
  'artifactRegistryShowRoute',
  {
    path: '/orgs/:org/artifacts/:id',
    queries: [mainQuery<ArtifactRegistryShowRoutePayload>()],
  },
)
